/**
 * Match Data Integrations cards to registered sources and opportunity tags.
 * Display names like "Canada Tenders" must resolve to canada_tenders.
 */

export function normalizeIntegrationKey(value: string | null | undefined): string {
  let token = String(value || '').trim().toLowerCase();
  if (token.startsWith('api://')) {
    token = token.slice(6);
  }
  return token.replace(/[\s-]+/g, '_').replace(/_+/g, '_').replace(/^_+|_+$/g, '');
}

export function findSourceByIntegrationType(
  sources: any[],
  integrationType: string
): any | undefined {
  const want = normalizeIntegrationKey(integrationType);
  if (!want) return undefined;
  return sources.find((source) => {
    if (source?.type && source.type !== 'api_integration') return false;
    const meta = source.meta || source.metadata || {};
    const candidates = [meta.integration_type, source.name, source.uri];
    return candidates.some((candidate) => normalizeIntegrationKey(candidate) === want);
  });
}

export function entityCountsBySourceId(
  sources: Array<{ source_id?: string; entity_count?: number }>
): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const row of sources) {
    if (!row?.source_id) continue;
    counts[row.source_id] = Number(row.entity_count ?? 0);
  }
  return counts;
}
